import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import{AnnualComplianceModule} from 'app/annual-compliance/annual-compliance.module';
import { SharedModule } from 'app/shared.module';
import { StepperContainerComponent } from 'app/shared/stepper/stepper-container/stepper-container.component';
import { AuthWebService } from "../../services/authweb.service";

@Component({
  selector: 'app-complianceprocesses',
  templateUrl: './complianceprocesses.component.html',
  styleUrls: ['./complianceprocesses.component.scss']
})
export class ComplianceprocessesComponent implements OnInit {

  @Input() isDocumentInProgress: string = 'true';
  @Input() isPaymentInProgress: string = 'true';
  @Input() isConfirmationInProgress: string = 'true';
  complianceId:any;
  @ViewChild(StepperContainerComponent) StepperContainer;
  dataCntrl: any = { carrierID: -1, permittypeSelected: false, selectedtype: '', disableTypes: false, processStarted: false, currentTab: '', formValid: false, isViewEditControl: false, carrier: {}, application: {}, permit: {}, permittype: {}, vehicles: [], permitTypesDocLinks: [] };
  isExternalRole: boolean = true;

  constructor(private activeRoute: ActivatedRoute, private authWebService: AuthWebService) { }

  ngOnInit(): void {
    if (!this.authWebService.userData.Roles[0].IsExternalRole) {
      this.isExternalRole = false;
    }
  }

  goNext(){
    this.StepperContainer.activeStepper.isProgress = 'false';
    this.StepperContainer.next();
  }
  prevStep(){
    this.StepperContainer.previous();
  }

}
